var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-gray-100 py-6",
      staticStyle: { height: "calc(100vh - 70px)" }
    },
    [
      _c(
        "div",
        {
          staticClass: "Polaris-Box max-w-xl mx-auto",
          staticStyle: {
            "--pc-box-background": "var(--p-surface)",
            "--pc-box-border-radius": "var(--p-border-radius-2)",
            "--pc-box-padding-block-end-xs": "var(--p-space-4)",
            "--pc-box-padding-block-end-sm": "var(--p-space-5)",
            "--pc-box-padding-block-start-xs": "var(--p-space-4)",
            "--pc-box-padding-block-start-sm": "var(--p-space-5)",
            "--pc-box-padding-inline-start-xs": "var(--p-space-4)",
            "--pc-box-padding-inline-start-sm": "var(--p-space-5)",
            "--pc-box-padding-inline-end-xs": "var(--p-space-4)",
            "--pc-box-padding-inline-end-sm": "var(--p-space-5)",
            "--pc-box-shadow": "var(--p-shadow-card)"
          }
        },
        [
          _c("div", { staticClass: "Polaris-SettingAction" }, [
            _vm._m(0),
            _c("div", { staticClass: "Polaris-SettingAction__Action" }, [
              _c(
                "button",
                {
                  staticClass: "Polaris-Button Polaris-Button--primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.createNew("Abandoned")
                    }
                  }
                },
                [_vm._m(1)]
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "Polaris-Box",
              staticStyle: {
                "--pc-box-padding-block-start-xs": "var(--p-space-5)"
              }
            },
            [
              _c(
                "ul",
                _vm._l(_vm.templates, function(template) {
                  return _c("TemplateItem", {
                    key: template.id,
                    attrs: { template: template },
                    on: {
                      edit: function($event) {
                        return _vm.onEdit($event, "Abandoned")
                      },
                      delete: function($event) {
                        return _vm.onDelete($event, "Abandoned")
                      }
                    }
                  })
                }),
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "Polaris-Box max-w-xl mx-auto mt-4",
          staticStyle: {
            "--pc-box-background": "var(--p-surface)",
            "--pc-box-border-radius": "var(--p-border-radius-2)",
            "--pc-box-padding-block-end-xs": "var(--p-space-4)",
            "--pc-box-padding-block-end-sm": "var(--p-space-5)",
            "--pc-box-padding-block-start-xs": "var(--p-space-4)",
            "--pc-box-padding-block-start-sm": "var(--p-space-5)",
            "--pc-box-padding-inline-start-xs": "var(--p-space-4)",
            "--pc-box-padding-inline-start-sm": "var(--p-space-5)",
            "--pc-box-padding-inline-end-xs": "var(--p-space-4)",
            "--pc-box-padding-inline-end-sm": "var(--p-space-5)",
            "--pc-box-shadow": "var(--p-shadow-card)"
          }
        },
        [
          _c("div", { staticClass: "Polaris-SettingAction" }, [
            _vm._m(2),
            _c("div", { staticClass: "Polaris-SettingAction__Action" }, [
              _c(
                "button",
                {
                  staticClass: "Polaris-Button Polaris-Button--primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.createNew("Order")
                    }
                  }
                },
                [_vm._m(3)]
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "Polaris-Box",
              staticStyle: {
                "--pc-box-padding-block-start-xs": "var(--p-space-5)"
              }
            },
            [
              _c(
                "ul",
                _vm._l(_vm.orderTemplates, function(template) {
                  return _c("TemplateItem", {
                    key: template.id,
                    attrs: { template: template },
                    on: {
                      edit: function($event) {
                        return _vm.onEdit($event, "Order")
                      },
                      delete: function($event) {
                        return _vm.onDelete($event, "Order")
                      }
                    }
                  })
                }),
                1
              )
            ]
          )
        ]
      ),
      _vm.showModal
        ? _c("TemplateModal", {
            attrs: {
              template: _vm.currentTemplate,
              templateType: _vm.templateType
            },
            on: {
              edit: _vm.onUpdate,
              close: _vm.closeModal,
              create: _vm.onCreate
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Polaris-SettingAction__Setting" }, [
      _c(
        "div",
        {
          staticClass: "Polaris-Inline",
          staticStyle: {
            "--pc-inline-align": "start",
            "--pc-inline-block-align": "center",
            "--pc-inline-wrap": "wrap",
            "--pc-inline-gap-xs": "var(--p-space-4)"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "Polaris-AlphaStack",
              staticStyle: {
                "--pc-stack-align": "start",
                "--pc-stack-order": "column",
                "--pc-stack-gap-xs": "var(--p-space-2)"
              }
            },
            [
              _c(
                "h2",
                {
                  staticClass:
                    "Polaris-Text--root Polaris-Text--headingLg Polaris-Text--semibold"
                },
                [_vm._v(" Abandoned Cart Templates ")]
              )
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [
        _vm._v("Create new")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Polaris-SettingAction__Setting" }, [
      _c(
        "div",
        {
          staticClass: "Polaris-Inline",
          staticStyle: {
            "--pc-inline-align": "start",
            "--pc-inline-block-align": "center",
            "--pc-inline-wrap": "wrap",
            "--pc-inline-gap-xs": "var(--p-space-4)"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "Polaris-AlphaStack",
              staticStyle: {
                "--pc-stack-align": "start",
                "--pc-stack-order": "column",
                "--pc-stack-gap-xs": "var(--p-space-2)"
              }
            },
            [
              _c(
                "h2",
                {
                  staticClass:
                    "Polaris-Text--root Polaris-Text--headingLg Polaris-Text--semibold"
                },
                [_vm._v(" Order Templates ")]
              )
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [
        _vm._v("Create new")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }